import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { closeDialog } from "@shared/store/dialog.duck";
import { smallTablet } from '@shared/ui/atoms/MediaQueries';
import Dialog from '@shared/ui/molecules/Dialog';
import styled from "styled-components";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { useTranslation } from "react-i18next";
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import Colours from '@shared/ui/atoms/Colours';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { updateImportantNote } from "../data/hospitality-management.duck";

export function HospitalityEditImportantNoteDialog(props: Props) {
  const {t} = useTranslation();
  const textRef = useRef<any>(null);
  const [note, setNote] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    setNote(props.payload.office.hospitalityImportantNote || '')
  }, [props.payload.office.hospitalityImportantNote]);

  const close = () => {
    dispatch(closeDialog());
  }

  const onSaveClicked = () => {
    dispatch(updateImportantNote({office: props.payload.office, note: note}));
    dispatch(closeDialog());
  }

  const onTextChange = (aString: string) => {
    setNote(aString);
  }

  return (
    <DialogWrapper isOpen={true} onClose={close}>
      <HeadlineMedium style={{marginBottom: 16}}>{t('settings.manage-hospitality.edit-important-note')}</HeadlineMedium>
      <TextArea ref={textRef} defaultValue={''} value={note} onChange={(e) => onTextChange(e.target.value)} />
      <PrimaryButton text={'button.save'} click={onSaveClicked} fullWidth={true} style={{marginTop: 'auto'}} />
    </DialogWrapper>
  )
}

interface Props {
  payload: {
    office: OfficeEntity;
  };
}


const DialogWrapper = styled(Dialog)<any>`
  &.dialog {
    width: 100vw;
    height: 100vh;
    padding: 20px 0 0 0;
    @media (${smallTablet}) {
      padding: 64px 48px;
      max-width: 100%;
      min-height: 400px;
      width: unset;
      height: unset;
    }
  }
  .dialog__contentContainer, .dialog__content {
    width: 100%;
    padding-top: 0;
    @media (${smallTablet}) {
      width: 400px;
      min-height: 410px;
    }
  }
  .dialog__content {
    display: flex;
    flex-direction: column;
  }
  .textField__label {
    color: ${Colours.black} !important;
  }
`

const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  margin-bottom: 2px;
  padding: 4px 8px;
  font-size: 16px;
  font-family: "soleil", sans-serif;
  white-space: pre-wrap;
`
